import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const approvedPaymentAction = createAsyncThunk(
    'payment-varify',
    async (data, { rejectWithValue }) => {

       
        try {
            // const res = await axios.post(`/admins/api/payment-varify`,{payment_id:data.payment_id,publisher_id:data.publisher_id})
            const res = await axios.post(`/admins/api/payment-varify`,{payment_id:data.payment_id,publisher_id:data.publisher_id?._id})
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const approvedPaymentSlice = createSlice({
    name: 'payment-varify',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(approvedPaymentAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(approvedPaymentAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(approvedPaymentAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const approvedPaymentReducer = approvedPaymentSlice.reducer    